// Meta (Facebook) Pixel utility
// Injects the pixel script at runtime, so no edits to public/index.html are needed.
// Docs: https://developers.facebook.com/docs/meta-pixel

const PIXEL_ID = process.env.REACT_APP_META_PIXEL_ID || "1677888260342180";

let initialized = false;

// Call once, as early as possible (index.js)
export const initMetaPixel = () => {
  if (typeof window === "undefined" || initialized) return;

  if (!window.fbq) {
    /* eslint-disable */
    !(function (f, b, e, v, n, t, s) {
      if (f.fbq) return;
      n = f.fbq = function () {
        n.callMethod
          ? n.callMethod.apply(n, arguments)
          : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = true;
      n.version = "2.0";
      n.queue = [];
      t = b.createElement(e);
      t.async = true;
      t.src = v;
      s = b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t, s);
    })(
      window,
      document,
      "script",
      "https://connect.facebook.net/en_US/fbevents.js"
    );
    /* eslint-enable */
  }

  window.fbq("init", PIXEL_ID);
  window.fbq("track", "PageView");
  initialized = true;
};

// Fire on every SPA route change (ScrollToTop.jsx calls this)
export const trackPageView = () => {
  if (typeof window !== "undefined" && window.fbq) {
    window.fbq("track", "PageView");
  }
};

// Standard Meta events: Purchase, CompleteRegistration, InitiateCheckout,
// AddToCart, Lead, ViewContent, etc.
// eventID (optional) is used to dedupe with server-side (CAPI) events.
export const trackEvent = (eventName, params = {}, eventID) => {
  if (typeof window !== "undefined" && window.fbq) {
    if (eventID) {
      window.fbq("track", eventName, params, { eventID });
    } else {
      window.fbq("track", eventName, params);
    }
  }
};

// For events that aren't in Meta's standard list
export const trackCustomEvent = (eventName, params = {}) => {
  if (typeof window !== "undefined" && window.fbq) {
    window.fbq("trackCustom", eventName, params);
  }
};